export default __webpack_public_path__ + "static/media/planning_icon.3d79fafd.svg";